import DashboardModel from './dashboard.model'

let storeContent = utils.generateStore({
   DashboardModel,
   dashboards: [],
   selected_dashboards: [],
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async addDashboard(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'insert',
                  data: {
                     record: {
                        code: data.code,
                        name: data.name,
                        visuals: data.visuals,
                        filters: data.filters,
                        roles: data.roles,
                        is_main_dashboard: data.is_main_dashboard,
                        description: data.description,
                     }
                  },
                  meta_data: {
                     service: "analytics",
                     collection: "dashboard",
                  }
               })

               await payload.ref.resetForms()
               await ctx.dispatch('fetchDashboard')
               ctx.commit('show_create_modal', false)
               $notify('success', 'Dashboard Created', `Dashboard ${data.name} successfully created.`, 5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async updateDashboard(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'update',
                  data: {
                     id: ctx.getters.selected_dashboards[0]._id,
                     record: {
                        code: data.code,
                        name: data.name,
                        visuals: data.visuals,
                        filters: data.filters,
                        roles: data.roles,
                        is_main_dashboard: data.is_main_dashboard,
                        description: data.description,
                     }
                  },
                  meta_data: {
                     service: "analytics",
                     collection: "dashboard",
                  }
               })

               await payload.ref.resetForms()
               await ctx.dispatch('fetchDashboard')
               ctx.commit('show_edit_modal', false)
               $notify('success', 'Dashboard Updated', `Dashboard ${data.name} successfully updated.`, 5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async deleteDashboard(ctx, payload) {
         try {
            ctx.commit('loading', true)

            for (const dashboard of ctx.getters.selected_dashboards) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'delete',
                  data: {
                     id: dashboard._id,
                  },
                  meta_data: {
                     service: "analytics",
                     collection: "dashboard",
                  }
               })
            }

            await ctx.dispatch('fetchDashboard')
            ctx.commit('show_delete_modal', false)
            $notify('success', 'Dashboard Deleted', `<b>${ctx.getters.selected_dashboards.length}</b> Dashboard successfully deleted.`, 5)

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      handleActions(ctx, payload) {
         if (payload.action === 'dashboard:edit') {
            let DashboardModel = ctx.getters.DashboardModel
            DashboardModel.forms.editDashboard.data = payload.rows[0]

            ctx.commit('DashboardModel', DashboardModel)
            ctx.commit('show_edit_modal', true)
            ctx.commit('selected_dashboards', payload.rows)
         } else if (payload.action === 'dashboard:delete') {
            ctx.commit('delete_message', `<b>${payload.rows.length}</b> Dashboard`)
            ctx.commit('show_delete_modal', true)
            ctx.commit('selected_dashboards', payload.rows)
         } else if (payload.action === 'dashboard:view') {
            // $session.set('selected_dashboards',payload.rows[0])
         } else if (payload.action === 'dashboard:Dashboards-View_Dashboard') {
            ctx.getters.router.push({name: 'Dashboards-View_Dashboard', params: {dashboard_id: payload.rows[0]._id}})
         }
      },
      async fetchDashboard(ctx) {
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {

                     }
                  }
               },
               meta_data: {
                  service: "analytics",
                  collection: "dashboard",
               }
            })
            ctx.commit('dashboards', res.result.records);
         } catch (err) {
            throw err
         }
      },
      async fetchFormData(ctx) {
         try {
            // Fetch Schema
            let res = await api.fetchEndpointSecure({
               resource: 'commons',action: 'list',
               data: {},
               meta_data: {service: "analytics",collection: "visualization"}
            })


            let Model = utils.appendSelectData({
               Model: ctx.getters.DashboardModel,
               forms: ['addDashboard','editDashboard'],
               model: 'visuals',
               label: 'name',
               dataField: '_id',
               data: await res.result.records.sort((a,b) => {return b.last_update - a.last_update})
            })

            res = await api.fetchEndpointSecure({
               resource: 'commons',action: 'list',
               data: {

               },
               meta_data: {service: "analytics",collection: "filter"}
            })


            Model = utils.appendSelectData({
               Model: ctx.getters.DashboardModel,
               forms: ['addDashboard','editDashboard'],
               model: 'filters',
               label: 'name',
               dataField: '_id',
               data: await res.result.records.sort((a,b) => {return b.last_update - a.last_update})
            })

            res = await api.fetchEndpointSecure({
               resource: 'urmg',action: 'role:get_all',
               data: {},
               meta_data: {}
            })


            Model = utils.appendSelectData({
               Model: ctx.getters.DashboardModel,
               forms: ['addDashboard','editDashboard'],
               model: 'roles',
               label: 'name',
               dataField: 'code',
               data: await res.result.roles
            })
            ctx.commit('DashboardModel', Model)
         } catch (err) {
            throw err
         }
      },
      async fetchData(ctx) {
         try {
            await ctx.dispatch('fetchFormData')
            await ctx.dispatch('fetchDashboard')
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
   }
};